import { put, takeEvery } from "redux-saga/effects";

import { addNotification, loading } from "layouts/AppLayout/modules";
import { getApi } from "../../../sagas";
import { SUBMIT_APP, SubmitAppAction, submitAppEnd } from "../actions";

export function* submitApp(action: SubmitAppAction) {
    const { payload } = action;
    const { appId, payments } = payload;

    const api = getApi(payload);

    try {
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const result = yield api.submitApp(appId, payments);
        yield put(submitAppEnd(undefined, result));
        yield put(addNotification(`${appId} successfully submitted.   Please refresh your page.`));
    } catch (e) {
        yield put(submitAppEnd(e));
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchSubmitApp() {
    yield takeEvery(SUBMIT_APP, submitApp);
}
